import { render, staticRenderFns } from "./RegisteredKeeper.vue?vue&type=template&id=ae7bd25a&"
import script from "./RegisteredKeeper.vue?vue&type=script&lang=js&"
export * from "./RegisteredKeeper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports